export const addProtocolIfMissing = (url) => {
  if (url.match(/^http.*/)) {
    return url;
  }

  return `https://${url}`;
};

export const parseUrl = (rawUrl) => {
  const prepared = addProtocolIfMissing(rawUrl);
  return new URL(prepared);
};

export const getHostname = (url) => {
  if (!url) {
    return '';
  }
  return parseUrl(url).hostname;
};

export const isLocalhost = (rawUrl) => {
  const hostname = getHostname(rawUrl);
  return hostname === 'localhost' || hostname === '127.0.0.1';
};

export const isTesting = (rawUrl) => {
  // "staging" URLs also have "kcc" part, so let's check if this one is not from them first
  if (isStaging(rawUrl)) {
    return false;
  }

  const hostname = getHostname(rawUrl);
  return hostname.includes('kcc');
};

export const getSearchParamValue = (rawUrl, key) => {
  return parseUrl(rawUrl).searchParams.get(key);
};

export const isStaging = (rawUrl) => {
  const hostname = getHostname(rawUrl);
  return hostname.includes('staging.keywee.io');
};

export const isProduction = (rawUrl) => {
  const hostname = getHostname(rawUrl);
  return hostname.includes('anyword.com');
};

export const isTeadsProduction = (rawUrl) => {
  const hostname = getHostname(rawUrl);
  return hostname.includes('teads.anyword.com') || hostname.includes('teads-test.keywee.sh');
};

export const isNotProduction = (rawUrl) =>
  isLocalhost(rawUrl) || isStaging(rawUrl) || isTesting(rawUrl);

export const preparePlatformUrl = (path = '') =>
  `${window.location.protocol}//${window.location.host}${path}`;

export const cleanUrl = (url) => {
  let cleanedUrl = url.replace(/^(https?:\/\/)?/i, '');
  if (cleanedUrl.endsWith('/') || cleanedUrl.endsWith('.')) {
    cleanedUrl = cleanedUrl.slice(0, -1); // Remove trailing slash or period if it exists
  }
  return cleanedUrl;
};

/**
 * Loosely validate a URL `string`.
 * Source: https://github.com/segmentio/is-url
 *
 * @param {String} str - URL string to validate
 * @param {Object} [options] - options
 * @param {Boolean} [options.dontAddProtocol] - should we prepend HTTPS if missing?
 * @returns {Boolean} - true if the string is a valid URL
 */
export const isValidUrl = (str, options) => {
  /* eslint-disable no-useless-escape */
  const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
  const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
  const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
  /* eslint-enable no-useless-escape */

  if (typeof str !== 'string') {
    return false;
  }

  const strWithProtocol = !options?.dontAddProtocol ? addProtocolIfMissing(str) : str;
  const match = strWithProtocol.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }

  const everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  return (
    localhostDomainRE.test(everythingAfterProtocol) ||
    nonLocalhostDomainRE.test(everythingAfterProtocol)
  );
};
